<template>
  <v-container width="100%" class="px-0 mx-0 pt-3" fluid>
    <h1 class="text-center mt-10">Отзывы наших клиентов:</h1>
    <v-row>
      <v-col
          v-for="review in reviews"
          :key="review.name"
          :cols="cols"
          max-height="500px"
          class="my-10"
      >
        <v-card
            class="mx-0 my-10 rounded-xl"
            color=""
            height="100%"
            elevation="5"
          >
            <v-card-title>
              <v-icon
                left
                class="ml-2"
                size="30"
              >
                $vuetify.icons.vk
              </v-icon>
<!--              <span class="">VK</span>-->
            </v-card-title>

            <v-card-text class="px-5">
              {{ review.text }}
            </v-card-text>
            <v-card-actions class="py-0 mx-0 card-actions">
              <v-list-item>
                <v-list-item-avatar color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    :src="require('../assets/' + review.id + '.jpeg')"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>

                  <v-btn
                      :href=review.link
                      target="_blank"
                      class="align-self-start subtitle-1 text-capitalize"
                      :ripple="false"
                      plain
                  >
                  <v-list-item-title>{{ review.name }}</v-list-item-title>

                  </v-btn>
                </v-list-item-content>

              </v-list-item>
            </v-card-actions>

          </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Reviews.vue",
  data() {
    return {
      reviews: [
        {
          name: "Дмитрий Ёлгин",
          text: "Ваша статистика на МК - это просто бомба. Если знаешь и умеешь разбираться в алгоритмах, это не заменимый инструмент! А если не умеешь - тогда тем более. Я выхожу с её помощью на стабильный плюс. Сама по себе статистика простая и лаконичная, явно сделанная с учётом многолетнего опыта. Не будет преувеличением сказать что я очень благодарен создателям за такое чудо😍😍😍",
          link: "https://vk.com/id410179001",
          id: "1",
        },
        {
          name: "Михаил Курочкин",
          text: "С основателем и идейным вдохновителем сервиса я общаюсь с 2017 года и нет ни единого плохого слова в его адрес, которое я мог бы сказать. Только хорошие слова и добрые пожелания. Человек знает что нужно для комфортной работы в сфере ставок на МК и можете не сомневаться, сервис отвечает всем требованиям качества и удобства. Развиваемся дальше, надеюсь впереди только лучшее, ведь совершенству нет предела!😍",
          link: "https://vk.com/m21shka",
          id: "2",
        },

        {
          name: "Артур Абрамов",
          text: "Очень удобная и добротная статистика👍 С богатым выбором фильтров,с помощью которых начинаешь видеть разнообразные ситуации, а некоторые моменты получается увидеть с такого ракурса что всё становится очевидно. Нравится отзывчивость создателей и готовность внедрять любые идеи клиентов. Лично я доволен таким качественным инструментом)😍",
          link: "https://vk.com/id57129664",
          id: "3",
        },
        {
          name: "Аслан Беккалиев",
          text: "Добрый день! Хочу оставить свой отзыв, потому что сервис действительно бомбовый: доступно множество фильтров, позволяющих взглянуть на ситуацию под другим углом, что значительно увеличивает проходимость ставок! Адаптирован под телефон, очень удобно потому что 90% анализа я совершаю через мобильное устройство. Получается делать стабильный плюс даже в дороге за рулем. Рекомендую!😍",
          link: "https://vk.com/id27920229",
          id: "4",
        },

        {
          name: "Андрей Познанский",
          text: "Иногда хочется вспомнить былое и совершить пару ставок, поэтому периодически слежу за новинками в мире Мортал Комбата. Когда спросил знакомых кто занимается МК на постоянной основе о том, каким сервисом лучше воспользоваться - сказали что однозначно это Universtat. Приобрёл и полностью всем доволен - шикарный дизайн, множество фильтров, быстрая реакция технической поддержки. Сразу выслали обучающий урок и подробно ответили на все вопросы, после чего отбил подписку за час.\n😍",
          link: "https://vk.com/anubis84",
          id: "5",
        },

        {
          name: "Иван Апёнышев",
          text: "Universtat - один из самых удобных и функциональных сервисов статистики!\n" +
              "Родная МКХ теперь анализируется такими фильтрами, что лучшего для заработка на ставках и не пожелать! Для меня это уже как своеобразная форма медитации - каждый день зависать в статистике и рассматривать в разноцветных квадратиках алгоритмы. Напоминает фильм \"Матрица\", только здесь ещё и заработать можно)\n" +
              "Пользуюсь с удовольствием, зависаю каждый день и результатами более чем доволен!\n😍",
          link: "https://vk.com/erudirone",
          id: "6",
        },
        // {
        //   name: "Дата",
        //   text: "date",
        //   avatar: "Дата"
        // },
      ]
    }
  },
  computed: {
    cols() {
      const points = {
        "xs": 12,
        "sm": 12,
        "md": 6,
        "lg": 4,
        "xl": 4
      }
      return points[this.$vuetify.breakpoint.name]
    },
  }
}
</script>

<style scoped>

.card-actions {
  position: absolute;
  margin-bottom: 10px;
  bottom: 0;
}

.underline {
  text-decoration: underline !important;
  /* text-underline-offset: 2px; */
  text-underline-position: under left;
  /* text-underline-width: 2px; */
  text-decoration-thickness: 1px;
  text-decoration-color: #000;
  /* background: #cccccc; */
}
</style>